// import type { Me } from '@amp/musickit';
// import type { MusicAPIResponse } from '@jet-app/music/music-api/requestMusicAPIResource';
import { SubscriberType } from '~/utils/subscription';
// import type { User } from './types';
// import { makeUser } from './internal';

export * from './types';

// interface MeAPIEntity {
//     attributes: {
//         avatarArtwork: any;
//         restrictions: any;
//     };
// }

interface MeAPISubscription {
    active: boolean;
    storefront: string;
}

// interface MeAPIMeta {
//     subscription: MeAPISubscription;
//     challenge: {
//         subscriptionCapabilities: string[];
//     };
// }

export function isPremiumSubscriber(subscriberType: SubscriberType) {
    return subscriberType === SubscriberType.Premium;
}
